module.exports = __webpack_public_path__ + "static/media/get-logo.4a43ffc1.png";